// src/redux/contractCompanyApi.js
import { apiSlice } from "./apiSlice";

export const contractCompanyApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 계약업체 리스트 조회
        getContractCompanyList: build.query({
            query: () => ({
                url: "/api/admin/contract_company/v1",
                method: "get",
                headers: { token: true },
            }),
        }),
        // 계약업체 상세 조회 (contractCompanyId를 인자로 받아 조회)
        getContractCompanyDetail: build.query({
            query: (contractCompanyId) => ({
                url: `/api/admin/contract_company/v1/${contractCompanyId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetContractCompanyListQuery, useGetContractCompanyDetailQuery } = contractCompanyApi;
